import React from 'react'
import { Box, LinearProgress, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { DashboardTablePaper } from 'components'

import useStyles from './styles'

const TicketByAnswerOption = ({ answerOptionCounts = [], ...rest }) => {
  const classes = useStyles()

  return (
    <DashboardTablePaper
      title="Quantidade de Solicitação por Tipo de Pedido"
      tableType="ticket"
      className={classes.root}
      {...rest}
    >
      {answerOptionCounts?.map((answerOption) => (
        <Box px={2} key={answerOption.title}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>
              {answerOption.title}
            </Typography>
            <Typography className={classes.rowValue}>
              {answerOption.count}
            </Typography>
          </Box>
          <Box>
            <LinearProgress
              className={classes.lineBar}
              variant="determinate"
              value={100}
            />
          </Box>
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

TicketByAnswerOption.propTypes = {
  answerOptionCounts: PropTypes.array,
}

export default TicketByAnswerOption
